var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6649 1.81615L4.76839 7.381C4.56014 7.57431 4.29239 7.67389 4.02463 7.67389C3.75688 7.67389 3.48913 7.57431 3.28088 7.381L0.329676 4.59858C-0.0987253 4.19439 -0.110625 3.52661 0.299926 3.10485C0.710477 2.6831 1.38878 2.67138 1.81718 3.07556L4.02463 5.16092L9.17735 0.293138C9.60575 -0.111046 10.2841 -0.0934726 10.6946 0.322427C11.1052 0.744184 11.0933 1.41197 10.6649 1.81615Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxImage);
export default __webpack_public_path__ + "static/media/checkboxImage.5cb90e121ff64ab646ee3e69dea2b890.svg";
export { ForwardRef as ReactComponent };